import { ControllerFontType } from '@bymason-private/controller-v1-theme-provider';
import { Box, Card, CardActionArea, Divider, Typography } from '@bymason-private/legacy-pattern-components';
import { Route, RouterButton } from '@bymason-private/route-provider';
import { BuildResult, BuildStatus, JobModel } from '@bymason/controller-api-hooks';
import { formatLongDateTimeString } from '@bymason/utils';
import { routes } from '../../../router';

type MetricsSubheaderProps = {
  provisionedDeviceCount?: number;
  unprovisionedDeviceCount?: number;
  groupCount?: number;
  builds?: JobModel[];
  //   errors?: DashboardErrors;
  // };
};

export default function MetricsSubheader({
  provisionedDeviceCount,
  groupCount,
  builds,
}: // errors,
MetricsSubheaderProps) {
  return (
    <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
      {renderMetricItem(routes.Devices, 'Devices', provisionedDeviceCount)}
      {renderMetricItem(routes.Groups, 'Groups', groupCount)}
      <Box sx={{ flex: 1 }}>
        <Typography
          sx={{ background: 'white', flexShrink: 1, display: 'inline-flex', zIndex: 20, ml: 2 }}
          component='div'
          fontWeight='bold'
          fontSize='small'
        >
          Most recent builds
        </Typography>
        <Card
          elevation={0}
          sx={{
            mt: -1.5,
            zIndex: 10,
            borderRadius: 3,
            borderColor: 'grey',
            border: 1,
            color: 'lightgray',
            minWidth: '100%',
            height: 67,
          }}
        >
          {builds && !builds.length && (
            <Typography color='secondary' variant='body2' sx={{ mx: 'auto', display: 'table', py: 3 }}>
              No recent builds
            </Typography>
          )}
          {builds && builds.length == 1 && BuildInfo(builds[0])}
          {builds && builds.length > 1 && (
            <Box sx={{ display: 'flex' }}>
              {BuildInfo(builds[0])}
              <Divider orientation='vertical' flexItem sx={{ m: 0, borderColor: 'lightgray' }} />
              {BuildInfo(builds[1])}
            </Box>
          )}
        </Card>
      </Box>
    </Box>
  );

  function renderMetricItem(route: Route, lable: string, value?: number) {
    return (
      <Box>
        <Typography
          sx={{ background: 'white', flexShrink: 1, display: 'inline-flex', zIndex: 20, ml: 2 }}
          component='div'
          fontWeight='bold'
          fontSize='small'
        >
          {lable}
        </Typography>
        <Card
          elevation={0}
          sx={{
            mt: -1.5,
            zIndex: 10,
            borderRadius: 3,
            borderColor: 'grey',
            border: 1,
            color: 'lightgray',
          }}
        >
          <RouterButton
            buttonComponent={
              <CardActionArea
                sx={{
                  py: 2,
                  width: 80,
                  height: 65,
                  zIndex: 1,
                }}
              >
                <Typography fontSize={20} color='primary' sx={{ mx: 'auto', display: 'table' }}>
                  {value}
                </Typography>
              </CardActionArea>
            }
            route={route}
          />
        </Card>
      </Box>
    );
  }
}

function BuildInfo(build: JobModel) {
  return (
    <RouterButton
      route={routes.Project}
      state={{ name: build.project }}
      buttonComponent={
        <CardActionArea sx={{ py: 2 }}>
          <Box sx={{ display: 'flex', flexGrow: 1, justifyItems: 'start', gap: 2, pt: 0.5 }}>
            <Box
              sx={{
                ml: 2,
                '& > *': {
                  marginLeft: 3,
                  padding: '3px 8px',
                },
                '& > .info': {
                  backgroundColor: 'grey',
                },
                '& > .error': {
                  backgroundColor: 'error.light',
                  color: 'error.main',
                },
                '& > .success': {
                  backgroundColor: 'success.light',
                  color: 'success.main',
                },
                '& > .warn': {
                  backgroundColor: 'warning.light',
                  color: 'warning.main',
                },
              }}
            >
              {build.status === BuildStatus.Completed && build.result === BuildResult.Failed && (
                <Typography className='error' variant={ControllerFontType.Body300R} component='span'>
                  {`Failed`}
                </Typography>
              )}
              {build.status === BuildStatus.Completed && build.result === BuildResult.Success && (
                <Typography className='success' variant={ControllerFontType.Body300R} component='span'>
                  {`Success`}
                </Typography>
              )}
              {(build.status === BuildStatus.Created ||
                build.status === BuildStatus.Started ||
                build.result === BuildResult.Pending) && (
                <Typography className='warn' variant={ControllerFontType.Body300R} component='span'>
                  {`Pending...`}
                </Typography>
              )}
            </Box>
            <Box flex={1}>
              <Typography color='primary' sx={{ my: -1, p: 0, maxWidth: 240 }} noWrap textOverflow='ellipsis'>
                {build.project}
              </Typography>
              <Typography
                variant={ControllerFontType.Body300R}
                sx={{ my: -1, p: 0 }}
                color='gray'
                textOverflow='ellipsis'
                noWrap
              >
                {formatLongDateTimeString(build.createdAt)}
              </Typography>
            </Box>
          </Box>
        </CardActionArea>
      }
    />
  );
}
